import { render, staticRenderFns } from "./Sdgs.vue?vue&type=template&id=3b6c5b42&scoped=true"
import script from "./Sdgs.vue?vue&type=script&lang=js"
export * from "./Sdgs.vue?vue&type=script&lang=js"
import style0 from "./Sdgs.vue?vue&type=style&index=0&id=3b6c5b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c5b42",
  null
  
)

export default component.exports